/* eslint-disable */
import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import QueryableInterface from "@/interfaces/QueryableInterface";
import Base from "./Base";

export type SetAsReadParams = {
  [key: string]: string | number | null | Array<string> | Array<number>;
};
@Component
export default class NotificationsMixin extends Base {
  getNotifications(params: QueryableInterface, tag: string) {
    const queryString = this.paramsToQueryString(params);
    const url = API_ENDPOINT + `/report_jobs.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  setNotificationRead(params: SetAsReadParams, tag: string) {
    const queryString = this.paramsToQueryString(params);
    const url = API_ENDPOINT + `/report_jobs/set_as_read.json?`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: params,
    });
  }
}
